export const PROTECTION_CARD_TYPES = Object.freeze({
  TRIAL_IS_ACTIVE: 'trialIsActive',
  AUTOMATIC_PROTECTION_AVAILABLE: 'automaticProtectionAvailable',
});
